<template>
    <div>
        <md-list-item style="list-style-type: none">
            <div class="md-layout-item" style="padding-left: 0px">
                <div v-if="products" style="z-index: 1000">
                    <md-autocomplete
                        :md-fuzzy-search="false"
                        :md-options="products"
                        :value="value"
                        md-dense
                        :md-input-placeholder="'Zoek op product naam'"
                        :md-open-on-focus="true"
                        @input="onInputChange"
                        @md-changed="setProductList"
                        @md-opened="setProductList"
                        @md-selected="setSelectedProduct"
                        style="z-index: 1000; width: 100%"
                    >
                        <label>Product</label>
                        <template slot="md-autocomplete-item" slot-scope="{ item }">
                            {{ item.name + ' (' + item.product_number + ')' }}
                        </template>

                        <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                            <md-highlight-text :md-term="term">
                                {{
                                    item.name +
                                    ' (' +
                                    item.product_number +
                                    ')' +
                                    (item.specifications?.service ? ' - service' : '')
                                }}
                            </md-highlight-text>
                        </template>

                        <template slot="md-autocomplete-empty" slot-scope="{ term }">
                            No products matching "{{ term }}" were found!
                        </template>
                    </md-autocomplete>
                </div>
            </div>
            <div>
                <button @click="isScannerActive = true" class="barcode-button" style="width: 100%">
                    <md-icon>qr_code_scanner</md-icon>
                </button>
            </div>
        </md-list-item>

        <div class="barcode-scanner">
            <!-- Input field for manual barcode entry, will be the autocomplete -->

            <!-- Button to trigger barcode scanner -->
            <!-- Barcode scanner modal -->
            <div v-if="isScannerActive" class="scanner-modal">
                <stream-barcode-reader
                    @init="onScannerInit"
                    @detected="onBarcodeDetected"
                    @decode="onBarcodeDetected"
                    :pause="!isScannerActive"
                    @error="onBarcodeError"
                    :constraints="{ video: { facingMode: { ideal: 'environment' } } }"
                ></stream-barcode-reader>
                <button @click="closerScannerTest">Close Scanner</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Emit, Vue } from 'vue-property-decorator';
import { ReplaySubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { IProductSearchEntity, ProductApi, RequestSort } from '@phrospr/api-backend';
import toastr from 'toastr';
import { StreamBarcodeReader } from 'vue-barcode-reader';

@Component({
    components: { StreamBarcodeReader },
})
export default class ProductSearchModal extends Vue {
    filter: { name: string; product_number: string; active: boolean } = {
        name: '',
        product_number: '',
        active: true,
    };

    isScannerActive: boolean = false;

    get products() {
        return Promise.resolve(this.$store.state.productSearch);
    }

    value = '';
    selectedProductValue = '';

    searchTerm$ = new ReplaySubject(1);
    searchTermSubscription;

    scanning: boolean;

    constructor() {
        super();
        this.searchTermSubscription = this.searchTerm$
            .pipe(
                debounceTime(300),
                tap((searchTerm: string) => {
                    if (searchTerm === undefined) return;
                    this.filter.name = searchTerm ?? undefined;
                    this.filter.active = true;
                    this.searchProducts();
                }),
            )
            .subscribe();
        this.searchProducts();
    }

    closerScannerTest() {
        this.isScannerActive = false;
        this.value = '';
    }

    onScannerInit() {
        console.log('Barcode scanner initialized');
    }

    onBarcodeDetected(result) {
        console.log('Barcode detected:', result);
        // Set the barcode value to the detected result
        this.value = result;
        // Stop the scanner once a barcode is detected
        this.isScannerActive = false;
    }

    onBarcodeError(error) {
        console.error('Barcode Scanner Error:', error);
        this.isScannerActive = false;
        toastr.error('Failed to access the camera or scan the barcode.');
    }

    setProductList = searchTerm => {
        this.searchTerm$.next(searchTerm);
    };

    async searchProducts() {
        // Called from the constructor too, before vue-class-component has initialised the fields.
        const filter = this.filter ?? { name: '', product_number: '', active: true };
        const ProductSearchFilter: IProductSearchEntity = {
            filter,
            limit: 10,
            // With a term: best match first, then by name; without one: by name.
            sort: { order: RequestSort.ASC, column: filter.name ? 'relevance' : 'name' },
            offset: 0,
            show: {},
        };
        try {
            this.$store.commit('setProductSearch', (await ProductApi.listProducts(ProductSearchFilter)).data.records);
            this.$forceUpdate();
        } catch (e) {
            console.error(e);
            toastr.error('er ging iets mis bij het zoeken naar een product');
        }
    }

    onInputChange(event) {
        // Update value manually
        if (event === '') {
            console.log('Input field cleared');
            this.resetSearch();
        }
    }

    @Emit() resetSearch() {
        return;
    }

    @Emit() setSelectedProduct(selectedProduct) {
        this.selectedProductValue = selectedProduct.name + ' (' + selectedProduct.product_number + ')';
        return selectedProduct;
    }
}
</script>

<style scoped>
.barcode-scanner {
    text-align: center;
}
.scanner-modal {
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
µ .barcode-input-container {
    display: flex;
    align-items: center;
    position: relative;
}

input {
    flex: 1;
    padding: 10px;
    font-size: 16px;
}

.barcode-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    margin-left: 10px;
}

.barcode-button img {
    width: 24px;
    height: 24px;
}

.scanner-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.close-scanner-button {
    background: red;
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
}
</style>
